import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'
import api from '@/constant/END_POINT'

export type HealthClaimAutoAssignmentFormInput = {
  backofficeUserIds: string[]
}

const fetchCreateHealthClaimAutoAssignment = async (data: HealthClaimAutoAssignmentFormInput) => {
  const response = await httpClientPrivate.post(
    api.backoffice.createHealthClaimAutoAssignment,
    data,
  )

  return response.data
}

const useCreateHealthClaimAutoAssignment = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateHealthClaimAutoAssignment'],
    mutationFn: async (data: HealthClaimAutoAssignmentFormInput) =>
      fetchCreateHealthClaimAutoAssignment(data),
  })

  return mutation
}

export { useCreateHealthClaimAutoAssignment }
